export default __webpack_public_path__ + "static/media/HI-POOL ENCLOSURE-SHARJAH.fb12f289.jpg";